<template>
  <div class="group-post-edit clear">
    <div class="post-edit-l fl">
      <el-button class="post-back-btn" type="text" @click="goback()">
        <i class="el-icon-arrow-left"></i>返回</el-button>
      <template>
        <div class="input-post-tit">
          <input v-model.trim="search_title" type="text" placeholder="搜索标题">
          <i :class="[currentRow==null?'':'el-icon-delete']" @click="del_post_title(currentRow)"></i>
        </div>
        <el-table class="post-title-table" :show-header="false" highlight-current-row @current-change="handleCurrentChange" style="width: 100%" ref="post_tit_table" :data="post_title_data.filter(data => !search_title || data.title.toLowerCase().includes(search_title.toLowerCase()))">
          <el-table-column show-overflow-tooltip>
            <template slot-scope="scope" class="t_b_color">{{ scope.row.title}}</template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="total_number > page_size" @current-change="change_page" :page-size="page_size" :current-page="page_index" layout="prev, pager, next" :total="total_number">
        </el-pagination>
      </template>
    </div>
    <div class="post-edit-m fl">
      <template>
        <uploader class="uploader-example" ref="uploader" :options="uploadOptions" :file-status-text="statusText" @file-added="fileAdd" @file-removed="fileRemoved" @files-submitted="filesSubmitted" @file-success="fileSuccess" @file-error="fileFail">
          <uploader-unsupport></uploader-unsupport>
          <uploader-drop :class="[(resource_data.length+fileNumber)==3?'hideDrop':'']">
            <uploader-btn :directory="false" :single="true">上传附件</uploader-btn>
          </uploader-drop>
          <uploader-list></uploader-list>
        </uploader>
      </template>
      <ul>
        <li class="entry-file-list clear" v-for="(item, index) in resource_data" :key="index">
          <img v-if="item.file_type==1" src="../../../../public/images/format/resourceicon1.png" alt="文档">
          <img v-else-if="item.file_type==2" src="../../../../public/images/format/resourceicon2.png" alt="日志">
          <img v-else-if="item.file_type==3" src="../../../../public/images/format/resourceicon3.png" alt="图片">
          <img v-else-if="item.file_type==4" src="../../../../public/images/format/resourceicon4.png" alt="压缩文件">
          <img v-else-if="item.file_type==5" src="../../../../public/images/format/resourceicon5.png" alt="音乐">
          <img v-else-if="item.file_type==6" src="../../../../public/images/format/resourceicon6.png" alt="视频">
          <img v-else-if="item.file_type==7" src="../../../../public/images/format/resourceicon7.png" alt="应用程序">
          <img v-else-if="item.file_type==8||item.file_type==0" src="../../../../public/images/format/resourceicon8.png" alt="其他">
          <span class="fileName">{{item.name}}</span>
          <div>
            <!-- <span v-text="renderSize(item.filesize)"></span> -->
            <span>{{item.create_time}}</span>
          </div>
          <i class="el-icon-delete" @click="del_resource(item.id)"></i>
        </li>
      </ul>
    </div>
    <div class="post-edit-r fl">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :inline-message="true">
        <el-form-item class="post-title-item" prop="post_title">
          <el-input v-model.trim="ruleForm.post_title" maxlength="20" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item class="post-content-item">
          <tinymce id="d1" :plugins="plugins" :other_options="options" :toolbar1="toolbar1" :toolbar2="toolbar2" v-model="ruleForm.post_content" @editorInit="editorInit"></tinymce>
          <div class="post-content-count">
            <i>{{tinymceNum}}/</i><i class="gery">10000</i> </div>
        </el-form-item>
        <el-button class="post-btns-item" size="medium" type="text" @click="submitForm('ruleForm')">发帖子</el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
import axios from "../../../tools/axios";
import tinymce from "vue-tinymce-editor";
import CN from "./../../../assets/tinymce_languages/zh_CN.js";

export default {
  data() {
    return {
      user_login_id: this.$store.getters.userInfo.id,
      group_id: this.$route.query.id,
      post_id: this.$route.query.p_id,
      editFlag: this.$route.query.p_id ? true : false,
      page_index: 1,
      page_size: 12,
      total_number: 0,
      post_title_data: [],
      search_title: "",
      currentRow: null, //左侧点击选择的标题数据
      resource_id_string: "",
      //中间部分：上传资源
      resource_data: [],
      statusText: {
        success: "上传成功",
        error: "上传出错",
        uploading: "正在上传...",
        paused: "暂停",
        waiting: "等待上传"
      },
      uploadOptions: {
        target: this.BASE_URL + "/api/resource/res_upload",
        testChunks: false,
        headers: { Authorization: `Bearer ` + this.$g.access_token }
      },
      //右侧富文本
      p_t_index: 0,
      ruleForm: {
        post_title: "",
        post_content: ""
      },
      tinymceNum: 0, // 编辑器文本内容初始长度
      rules: {
        post_title: [
          { required: true, message: "您还没请输入标题" },
          { min: 3, max: 20, message: "长度在 3 到 20 个字符" }
        ],
        // post_content: [
        //   { required: true, message: "请填写内容" },
        //   { min: 3, max: 10000, message: "长度在 3 到 10000 个字符" }
        // ]
      },
      plugins: ["paste", "fullscreen", "link", "image"],
      toolbar1: " ",
      toolbar2: "formatselect  | fontsizeselect | forecolor backcolor | fontselect bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | removeformat | link,image", // 编辑器工具栏
      options: {
        images_upload_handler: this.images_upload_handler,
        language_url: CN,
        images_upload_url: this.BASE_URL + "/api/resource/res_upload",
        paste_data_images: true, // 粘贴的同时能把内容里的图片自动上传，非常强力的功能
        paste_convert_word_fake_lists: false, // 插入word文档需要该属性
        paste_webkit_styles: "all",
        paste_merge_formats: true,
        nonbreaking_force_tab: false,
        paste_auto_cleanup_on_paste: false
      },
      fileNumber: 0
    };
  },
  created() {
    this.getPostsList();
  },
  watch: {
    /**
     * 监听富文本的内容长度，判断是否超出规定内容
     */
    'ruleForm.post_content'(newVal, oldVal) {
      setTimeout(() => {
        let body = document.getElementById('d1_ifr').contentWindow.document.getElementsByTagName('body')[0].textContent;
        let newLen = body.replace(/\s/g, '').length;
        let oldLen = this.tinymceNum;

        // 判断输入的内容文本长度是否超过 10000
        if (newLen > 10000) {
          this.$message.warning('内容最大长度不可以超过 10000 个字');
          this.tinymceNum = oldLen;
          this.ruleForm.post_content = oldVal;
        } else {
          this.tinymceNum = newLen;
        }
      }, 300);
    }
  },
  methods: {
    //编辑器初始化
    editorInit() {
      //修改输入框内文字与边界的宽
      var test = document
        .getElementById("d1_ifr")
        .contentWindow.document.getElementById("tinymce");
      test.style.margin = "60px 25px 8px";
    },
    getPostsList() {
      let _params = {
        pid: 0,
        group_id: this.group_id,
        page_index: this.page_index,
        page_size: this.page_size,
        order: "create_time", //create_time,clicks
        drection: "DESC", //正序DESC，反序不填
        is_tree: 0, //是否获取下级（1是，0不是,不发不是）
        id: null, //讨论id
        create_id: this.user_login_id
      };
      let success = res => {
        this.post_title_data = res.data.data;
        this.page_index = parseInt(res.data.page_index);
        this.total_number = parseInt(res.data.data_sum);
        this.find_post_index(res.data.data); //跳到此页面进行编辑的时候，默认选中对应的帖子
      };
      this.$ajax.get("api/group/subject_group_chat", {
        params: _params,
        func: { success: success }
      });
    },
    //对比帖子id值,判断哪个标题被选中
    find_post_index(arr) {
      arr.find((value, index, arr) => {
        if (this.post_id == value.id)
          // table选中row事件
          this.$refs.post_tit_table.setCurrentRow(this.post_title_data[index]);
      });
    },
    // table选中时触发事件
    handleCurrentChange(val) {
      this.currentRow = val;
      if (val != undefined) {
        if (val.resource != undefined) {
          this.resource_data = val.resource;
          //拼字符串，号隔开
          this.resource_id_string = arrChangeString(val.resource, "id");
        }
        this.ruleForm.post_title = val.title;
        this.ruleForm.post_content = val.content;
      }
    },
    //删帖子
    del_post_title(_del_row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "confirm-them"
      })
        .then(() => {
          let del_params = {
            id: _del_row.id,
            title: _del_row.title,
            content: _del_row.content,
            resource_id: _del_row.resource_id,
            status: 0
          };
          this.change_post_data(del_params, "put");
          this.ruleForm.post_title = "";
          this.ruleForm.post_content = "";
          this.goback();
        })
        .catch(() => { });
    },
    // 新建帖子/编辑帖子公用函数
    change_post_data(_params, _method) {
      let success = res => {
        this.$message.success(res.msg);
        this.goback();
        this.getPostsList();
      };
      let fail = res => {
        this.$message.error(res.msg);
      };
      if (_method == "post") {
        this.$ajax.post('api/group/subject_group_chat', _params, { func: { success: success,fail:fail } })
      } else if (_method == "put") {
        this.$ajax.put('api/group/subject_group_chat', _params, { func: { success: success,fail:fail } })
      }
    },
    // 引入common.js里的公用函数，格式化文件大小
    renderSize(value) {
      return renderSize(value);
    },
    fileAdd(file) {
      if (file.size > 100 * 1024 * 1024) {
        this.$message.error('附件大小不能超过100M');
        file.ignored = true;
        return false;
      }
      document.getElementsByClassName("uploader-btn")[0].children[0].disabled = true;
      document.getElementsByClassName("uploader-btn")[0].style = "cursor:not-allowed;background-color: #999;";
    },
    fileRemoved(file) {
      document.getElementsByClassName("uploader-btn")[0].children[0].disabled = false;
      document.getElementsByClassName("uploader-btn")[0].style = "cursor:pointer;background-color: #409EFF;";
    },
    filesSubmitted(files, fileList) {
      let ext = files[0].name.split(".").pop().toLocaleLowerCase();
      if (ext === "mpg") {
        this.$message.error("不允许上传的此类格式的文件");
        this.$refs.uploader.uploader.removeFile(files[0]);
        return false;
      }
    },
    //上传附件成功
    fileSuccess(rootFile, file, message, chunk) {
      var mess = eval("(" + message + ")");
       mess = handleResponseData(mess);
      var params = {
        file_path: mess.data.file_path,
        file_type: mess.data.file_type,
        file_name: mess.data.file_name,
        post_fix: mess.data.post_fix,
        group_id: this.group_id
      };
      let success = res => {
        this.$message.success(res.msg);
        if (this.resource_id_string === "") {
          this.resource_id_string += res.data;
        } else {
          this.resource_id_string += "," + res.data;
        }
        this.fileNumber++;
        document.getElementsByClassName("uploader-btn")[0].children[0].disabled = false;
        document.getElementsByClassName("uploader-btn")[0].style = "cursor:pointer;background-color: #409EFF;";

      };
      this.$ajax.post("/api/group/bind_chat_resource", params, {
        func: { success: success }
      });


    },
    // 上传附件失败
    fileFail(rootFile, file, message, chunk) {
      var mess = eval("(" + message + ")");
      if (parseInt(mess.error) === 401 && this.uploadRetryTimes > 0) {
        let callbcak = data => {
          this.uploadRetryTimes--;
          this.$refs.uploader.uploader.retry(file);
        };
        this.get_access_token(callbcak);
      } else {
        this.$message.error(mess.msg);
        document.getElementsByClassName("uploader-btn")[0].children[0].disabled = false;
        document.getElementsByClassName("uploader-btn")[0].style = "cursor:pointer;background-color: #409EFF;";
      }
    },
    //删除帖子附件
    del_resource(_id) {
      let success = res => {
        this.getPostsList();
        this.$message.success(res.msg);
      };
      this.$ajax({
        url: "api/resource/resource",
        method: "delete",
        params: {
          id: _id,
          del_type: 1
        },
        func: { success: success }
      });
    },
    //发帖子时验证
    submitForm(formName) {
      //判断附件是否还在上传
      if (this.$refs.uploader.uploader.isUploading() == true) {
        this.$message.error("附件还没上传完成");
        return false;
      }
      //判断内容
      this.$refs[formName].validate(valid => {
        if (valid) {
          let _resource_id = this.resource_id_string.replace(/(^\,*)|(\,*$)/g, ""); //去除资源id组成的字符串首尾的逗号
          //新增帖子
          let params_add = {
            title: this.ruleForm.post_title,
            content: this.ruleForm.post_content,
            pid: 0,
            resource_id: _resource_id,
            group_id: this.group_id
          };
          //编辑帖子
          let params_edit = {
            id: this.post_id,
            title: this.ruleForm.post_title,
            content: this.ruleForm.post_content,
            resource_id: _resource_id,
            status: 1,
            group_id: this.group_id
          };
          if (this.editFlag) {
            this.change_post_data(params_edit, "put");
          } else {
            this.change_post_data(params_add, "post");
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 图片上传三个参数，图片数据，成功时的回调函数，失败时的回调函数
    images_upload_handler(blobInfo, success, failure) {
      if (blobInfo.blob().type.indexOf("image/") === -1) {
        failure("只允许上传图片格式的文件");
      } else if (blobInfo.blob().size > 2048000) {
        failure("图片大小不能超过2M");
      } else {
        let formData = new FormData();
        formData.append("file", blobInfo.blob(), blobInfo.filename());
        let succ = data => {
          success(this.BASE_URL + data.data.data.file_path);
        };
        let fail = data => {
          failure(data.data.data.message);
        };
        const instance = axios.create({
          headers: {
            Authorization: `Bearer ${this.$g.access_token}`,
            DecisionPlatform: ` ${this.$g.access_token}`,
            token: localStorage.getItem("token")
          },
          withCredentials: true
        });
        instance
          .post("api/resource/res_upload", formData)
          .then(succ)
          .catch(fail);
      }
    },
    // 分页
    change_page(val) {
      this.page_index = val;
      this.getPostsList();
    },
    goback() {
      this.$router.back(-1);
    }
  },
  components: {
    tinymce
  }
};
</script>

<style lang="scss" scoped>
.main {
  padding: 0;
}
.hideDrop {
  opacity: 0;
  visibility: hidden;
}

</style>
